module.exports = __webpack_public_path__ + "img/exam_instructions_image.f1277a1e.jpg";